<!-- #86 -->
<template>
  <v-col class="mx-4 py-0 mt-2">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0 mr-5 mt-4"
        style="color: #23468c; font-weight: 500; width: 100%"
      >
        List of Attendance
      </div>
      <v-spacer></v-spacer>
    </div>
    <v-divider class="mt-1 mb-2"></v-divider>

    <v-data-table
      :headers="_headers"
      :items="list"
      :options.sync="options"
      :server-items-length="total"
      :loading="loader"
      class="elevation-1 mt-7"
      :items-per-page="25"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:[`item.overtime_cost`]="{ item }">
        {{ changeFormat(item.overtime_cost) }}
      </template>
      <template v-slot:[`item.overtime_in_min`]="{ item }">
        {{ changeNumberFormat(item.overtime_in_min) }}
      </template>
      <template v-slot:[`item.overtime_in_min`]="{ item }">
        {{ changeNumberFormat(item.overtime_in_min) }}
      </template>
      <template v-slot:[`item.total_cost`]="{ item }">
        {{ changeFormat(item.total_cost) }}
      </template>

      <template v-slot:[`item.overtime_flag`]="{ item }">
        {{ item.overtime_flag == 1 ? "Yes" : "No" }}
      </template>
      <template v-slot:[`item.is_approved`]="{ item }">
        {{
          item.is_approved == 1
            ? "Accepted"
            : item.is_approved == 2
            ? "Rejected"
            : item.is_approved == 3
            ? "Inactive"
            : item.is_approved == 0
            ? "Open"
            : ""
        }}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip
          bottom
          v-if="checkPermission('app_osl_overtime_cost:list_rate_card')"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="openDetails(item.rate_card_id)"
            >
              mdi-eye
            </v-icon>
          </template>
          <span>View Rate card</span>
        </v-tooltip>
      </template>
      <template v-slot:top>
        <template>
          <v-form>
            <v-row class="custom-row pl-5 pr-5">
              <v-col
                cols="12"
                sm="3"
                md="3"
                v-if="userCategory.user_category == 3"
              >
                <v-autocomplete
                  label="Vendor Name"
                  :items="vendors"
                  v-model="vendor_name"
                  item-text="vendor_name"
                  item-value="id"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col>
                <v-text-field
                  label="Employee Name"
                  v-model="employee_name"
                  outlined
                ></v-text-field
              ></v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  label="Overtime"
                  :items="vendorStatus"
                  v-model="overtime_flag"
                  item-text="text"
                  item-value="value"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  label="Employee Role"
                  :items="roles"
                  v-model="employee_type"
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3">
                <v-autocomplete
                  label="Is Approved"
                  :items="vendorStatus"
                  v-model="is_approved"
                  item-text="text"
                  item-value="value"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  label="Type of Holiday"
                  :items="dayTypes"
                  v-model="type_of_day"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateFilter"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      label="Start Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      clearable
                      @click:clear="clearInput('from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateFilter = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateFilterTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      label="End Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      clearable
                      @click:clear="clearInput('to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateFilterTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col class="text-right">
                <v-btn class="success" color="primary" @click="searchAll"
                  >Search</v-btn
                >
                <v-btn color="white" class="ml-4" @click="allClear"
                  >Clear</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
          <v-divider class="my-5"></v-divider>
        </template>
      </template>
    </v-data-table>
    <template>
      <v-row justify="center">
        <v-dialog v-model="summary" persistent width="700">
          <v-card class="pl-0">
            <v-card-title class="card-title"
              >Rate Card- Vendor Name: {{ ratecardData.vendor_name }} | Role :
              {{ ratecardData.role_of_employee }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mb-0 pb-0">
              <v-row class="pl-0">
                <v-col cols="6">
                  <v-col cols="12" class="pl-0">
                    <div>
                      <b>Rate Card Details </b>
                    </div>

                    <div class="col-md-12 d-flex p-0">
                      <div class="col-md-5 p-0 text-medium-emphasis">
                        Start Date From
                      </div>
                      <div class="text-left col-md-7 p-0 p-0">
                        {{ ratecardData.rate_card_start_date }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0">
                      <div class="col-md-5 p-0">Start Date To</div>
                      <div class="text-left col-md-7 p-0">
                        {{ ratecardData.rate_card_end_date }}
                      </div>
                    </div>
                  </v-col>
                </v-col>
                <v-col cols="6">
                  <v-col cols="12" class="pl-0">
                    <div><b>Cost Details</b></div>

                    <div class="col-md-12 d-flex p-0">
                      <div class="col-md-9 p-0 text-medium-emphasis">
                        Cost Per Month Per Employee (In AED)
                      </div>
                      <div class="text-left col-md-3 p-0 p-0">
                        {{ changeFormat(ratecardData.cost_per_month) }}
                      </div>
                    </div>

                    <div class="col-md-12 d-flex p-0">
                      <div class="col-md-9 p-0">
                        Weekday Overtime Cost Per Hour
                      </div>
                      <div class="text-left col-md-3 p-0">
                        {{ changeFormat(ratecardData.weekday_ot_cost_per_hr) }}
                      </div>
                    </div>

                    <div class="col-md-12 d-flex p-0">
                      <div class="col-md-9 p-0">
                        Weekend/Holiday Cost Per Hour
                      </div>
                      <div class="text-left col-md-3 p-0">
                        {{ changeFormat(ratecardData.weekend_ot_cost_per_hr) }}
                      </div>
                    </div>
                  </v-col>
                </v-col>
              </v-row>

              <v-divider></v-divider>
              <v-row class="pl-0">
                <v-col cols="6">
                  <v-col cols="12" class="pl-0">
                    <div><b>Other Details</b></div>

                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-10 p-0">
                        Fixed Daily Employee Count Per Day
                      </div>
                      <div class="text-left col-md-2 p-0">
                        {{
                          changeNumberFormat(
                            ratecardData.daily_employee_count_per_month
                          )
                        }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-10 p-0">Weekday Working Hours</div>
                      <div class="text-left col-md-2 p-0">
                        {{
                          changeNumberFormat(ratecardData.weekday_working_hours)
                        }}
                      </div>
                    </div>
                    <div class="col-md-12 d-flex p-0 m-0">
                      <div class="col-md-10 p-0">
                        Is Sunday is offical Working day?
                      </div>
                      <div class="text-left col-md-2 p-0">
                        {{ ratecardData.is_sunday_working == 1 ? "Yes" : "No" }}
                      </div>
                    </div>
                  </v-col>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="d-flex justify-end">
              <v-btn color="white" variant="text" @click="summary = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  mounted() {
    if (this.userCategory.user_category == 3) this.getvendorList();
  },
  data: () => ({
    dateFilterTo: false,
    dateFilter: false,
    from_date: null,
    to_date: null,
    updateItem: "",
    active: false,
    statusType: ["Approved", "Rejected"],
    selectedStatus: false,
    selectedVendor: null,
    vendors: [],
    saveLoader: false,
    vendorStatus: [
      { text: "Yes", value: 1 },
      { text: "No", value: 2 },
    ],
    roles: ["WHA", "RTO"],
    summary: false,
    headers: [
      {
        text: "Vendor name",
        value: "vendor_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Employee Name",
        value: "employee_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Employee Role",
        value: "employee_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Type of day",
        value: "type_of_day",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Start Date",
        value: "start_date_time",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "End Date",
        value: "end_date_time",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Overtime Cost (In AED)",
        value: "overtime_cost",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Overtime",
        value: "overtime_flag",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Overtime (In Hours)",
        value: "overtime_in_min",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Total time (In Hours)",
        value: "total_min_worked",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Total cost (In AED)",
        value: "total_cost",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Status",
        value: "is_approved",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Comments",
        value: "comments",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Actions",
        value: "action",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],

    list: [],
    options: {},
    totals: 0,
    total: 0,
    openStatusDialog: false,
    applicationItem: "",
    comment: null,
    employee_type: null,
    employee_name: null,
    type_of_day: null,
    overtime_flag: null,
    dayTypes: ["Weekday", "Weekend", "Holiday"],
    ratecardData: "",
    is_approved: null,
    loader: false,
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        this.fetchList();
      },
      deep: true,
    },
    optionsDetails: {
      handler() {
        if (this.optionsDetails.page !== 1 || this.previusPage) {
          this.previusPage = true;
          if (this.item !== undefined) this.editDetails(this.item);
        }
      },
      deep: true,
    },
  },
  created() {},
  computed: {
    _headers() {
      return this.headers.filter((i) => {
        if (this.userCategory.user_category == 5) {
          if (i.value !== "overtime_cost" && i.value !== "total_cost") {
            return true;
          }
        } else {
          return true;
        }
      });
    },
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    ...mapGetters(["userRole", "userCategory"]),
  },
  methods: {
    ...mapActions([
      "snackBar",
      "getattendanceList",
      "getvendorDropdown",
      "timesheetDetails",
      "activeStatus",
      "updateApplication",
      "getRateCardListDetails",
    ]),

    getvendorList() {
      this.vendorLoader = true;

      this.getvendorDropdown()
        .then((res) => {
          this.vendorLoader = false;
          this.vendors = res.data;
        })
        .catch(() => {
          this.vendorLoader = false;
        });
    },

    clearInput(val) {
      if (val == "to_date") {
        this.to_date = "";
      } else if (val == "from_date") {
        this.from_date = "";
      } else if (val !== null) {
        val = "";
      }
    },
    openDetails(id) {
      this.getRateCardListDetails(id).then((res) => {
        this.summary = true;
        this.ratecardData = res.data.records[0];
      });
    },
    allFilters() {
      this.loader = true;
      let obj = {
        vendor_id: this.vendor_name,
        employee_name: this.employee_name,
        employee_type: this.employee_type,
        type_of_day: this.type_of_day,
        overtime_flag: this.overtime_flag,
        from_date: this.from_date,
        is_approved: this.is_approved,
        to_date: this.to_date,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getattendanceList({ ...this.options, ...this.filtersArr })
        .then((res) => {
          this.loader = false;
          this.list = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    allClear() {
      this.from_date = null;
      this.to_date = null;
      this.is_approved = null;
      this.overtime_flag = null;
      this.type_of_day = null;
      this.employee_type = null;
      this.employee_name = null;
      this.vendor_name = null;

      this.filtersArr = [];
      this.fetchList();
    },

    fetchList() {
      this.list = [];
      this.loader = true;
      let params = {
        id: this.selectedVendor,
        ...this.options,
        ...this.filtersArr,
      };
      this.getattendanceList(params)
        .then((res) => {
          this.loader = false;
          this.list = res.data.records;

          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
  },
};
</script>
<style scoped>
.custom-footer {
  font-size: 17px;
  font-weight: bold;
  width: 100%;
  border-collapse: collapse;
  background-color: #add8e64f;
  margin-top: 70px; /* Adjust as needed */
  border: 1px solid gray; /* Add border styles as needed */
}
.custom-footer td {
  padding: 16px;
  background-color: #add8e64f;
  /* width: 500px; */
  border-top: 1px solid lightgray;
  text-align: left; /* Center the content */
}

.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.card-title {
  padding-left: 22px;
}
.p-0 {
  padding: 0px !important;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
</style>
